var _path, _path2, _g, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.001 512.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M503.172 88.276H8.828A8.829 8.829 0 0 0 0 97.104v317.792a8.829 8.829 0 0 0 8.828 8.828h494.345a8.829 8.829 0 0 0 8.828-8.828V97.104a8.83 8.83 0 0 0-8.829-8.828z",
    fill: "#464655"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe15a",
    d: "M255.999 105.931l11.195 58.482 32.721-49.746-12.037 58.314 49.268-33.438-33.437 49.269 58.314-12.038-49.747 32.722 58.482 11.194-58.482 11.194 49.747 32.722-58.314-12.038 33.437 49.268-49.268-33.437 12.037 58.315-32.721-49.747-11.195 58.481-11.193-58.481-32.723 49.747 12.039-58.315-49.269 33.437 33.438-49.268-58.314 12.038 49.746-32.722-58.482-11.194 58.482-11.194-49.746-32.722 58.314 12.038-33.438-49.269 49.269 33.438-12.039-58.314 32.723 49.746z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ff4b55"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 97.104v317.792a8.829 8.829 0 0 0 8.828 8.828H256L2.298 91.289C.91 92.848 0 94.852 0 97.104z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.999 423.724h247.172a8.829 8.829 0 0 0 8.828-8.828V97.104c0-2.252-.91-4.256-2.298-5.816L255.999 423.724z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4173cd",
    d: "M154.947 291.31h202.105l53.894-70.62H101.052z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M154.947 291.31l101.052 132.414L357.052 291.31z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAg);
export default __webpack_public_path__ + "static/media/ag.b50e4b8b1a37957da1c677a268e53de1.svg";
export { ForwardRef as ReactComponent };